<script>
import swal from 'sweetalert'

/**
 * Confirmation modal using SweetAlert
 */
export default {
  props: {
    text: {
      type: String,
      default: $t('Are you sure?'),
    },
    headerText: {
      type: String,
      default: $t('Confirmation'),
    },
    confirmButtonText: {
      type: String,
      default: $t('OK'),
    },
    cancelButtonText: {
      type: String,
      default: $t('No, go back!'),
    },
    type: {
      type: String,
      default: 'warning',
    },
    processingText: {
      type: String,
      default: $t('Now processing'),
    },
  },
  unmounted() {
    swal.close()
  },
  mounted() {
    const self = this
    swal(
      {
        title: this.headerText,
        text: this.text,
        showCancelButton: true,
        confirmButtonText: this.confirmButtonText,
        cancelButtonText: this.cancelButtonText,
        type: this.type,
        closeOnConfirm: false,
      },
      // eslint-disable-next-line prefer-arrow-callback
      function (isConfirm) {
        if (isConfirm) {
          self.$emit('confirmed')
          swal({
            title: $t('Processing'),
            text: self.processingText,
            type: 'success',
            showConfirmButton: false,
          })
        } else {
          self.$emit('cancelled')
        }
      },
    )
  },
  render() {
    return null
  },
}
</script>
